/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect } from 'react';

// Componentes.
import {
  Button,
  TextField,
  Grid,
  Stack,
  Typography,
  Box,
  Modal,
  FormControl,
  RadioGroup,
  Radio,
  FormLabel,
  FormControlLabel,
  IconButton,
  OutlinedInput,
  InputAdornment,
  InputLabel,
  Autocomplete,
  Select,
  MenuItem
} from '@mui/material';

import { CustomStyles } from '../styles/ModalStyles';

// Iconos
import PersonIcon from '@mui/icons-material/Person';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import LockIcon from '@mui/icons-material/Lock';

// Servicios
import msgNotificacion from '../../scripts/notification';
import SeguridadService from '../../services/seguridadService';
import EmpleadoService from '../../services/empleadoService';

// Validador de contraseñas
import validator from 'validator';

const ModalUsuarios = ({ setOpenModal, openModal, setNoChanges, dataUsuario, dataRoles, isEdit }) => {
  const inputEls = useRef([])
  const [rolSelected, setRolSelected] = useState('')
  const [empleadoSelected, setEmpleadoSelected] = useState(null)
  const [password, setPassword] = useState('')
  const [dataEmpleados, setDataEmpleados] = useState([])
  const [hiddenContrasena, setHIddenContrasena] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [showSuccess, setShowSuccess] = useState('')
  const [values, setValues] = useState({ nombre: '', isBloqueado: false })

  const validate = (value) => {
    try {
      setPassword(value)

      if (!value) {
        setErrorMessage('')
        return
      }

      if (validator.isStrongPassword(value, {
        minLength: 8, minLowercase: 1,
        minUppercase: 1, minNumbers: 1, minSymbols: 1
      })) {
        setErrorMessage('Es una contraseña segura')
        setShowSuccess('green')
      } else {
        setErrorMessage('No es una contraseña segura')
        setShowSuccess('red')
      }
    } catch (error) {
      console.error(error)
    }
  }

  const handleClickShowPassword = () => setShowPassword((show) => !show)

  const handleMouseDownPassword = (event) => {
    try {
      event.preventDefault();
    } catch (error) {
      console.error(error)
    }
  }

  const handleClose = () => {
    try {
      limpiar()
      setOpenModal(false)
    } catch (error) {
      console.error(error)
    }
  }

  const handleChange = (event) => {
    try {
      setValues({
        ...values,
        [event.target.name]: event.target.value
      })
    } catch (error) {
      console.error(error)
    }
  }

  const handleSelectChange = (event) => {
    try {
      setRolSelected(event.target.value)
    } catch (error) {
      console.error(error)
    }
  }

  const limpiar = () => {
    try {
      setValues({ ...values, nombre: '', isBloqueo: false })
      setEmpleadoSelected({ ...empleadoSelected, id: 0, label: 'Todos' })
      setPassword('')
      setRolSelected('')
    } catch (error) {
      console.error(error)
    }
  }

  const getEmpleados = async () => {
    try {
      EmpleadoService.getDatosCboSolicitud()
        .then((response) => {
          if (!response) {
            msgNotificacion('Error de conexión con la API, consulte al administrador del sitio.', 'error')
            return
          }

          if (response.Codigo === 1) {
            const data = response.Data

            setDataEmpleados(data?.Empleados)
          } else {
            setDataEmpleados([])
            msgNotificacion(response.Mensaje, 'info')
          }
        })
        .catch((error) => {
          msgNotificacion(error, 'error')
        })
    } catch (error) {
      console.error(error)
    }
  }

  const handleChangeEmpleado = (event, value) => {
    try {
      setEmpleadoSelected(value)
    } catch (error) {
      console.error(error)
    }
  }

  const guardarCambios = async () => {
    try {
      const data = {
        codUsuario: dataUsuario?.IdUsuario,
        codRol: parseInt(rolSelected),
        codEmpleado: empleadoSelected.id,
        nombre: values.nombre,
        contrasena: password,
        isBloqueado: values.isBloqueado === 'true' ? true : false
      }

      //console.log(data)

      if (isNaN(data.codRol)) {
        msgNotificacion('Seleccione el rol del Usuario', 'warning')
        inputEls.current['rol'].focus()
        return
      }

      if (data.codEmpleado <= 0) {
        msgNotificacion('Seleccione el empleado', 'warning')
        return
      }

      if (!data.nombre) {
        msgNotificacion('Escriba el nombre del usuario', 'warning')
        inputEls.current['nombre'].focus()
        return
      }

      if (!isEdit) {
        if (!data.contrasena) {
          msgNotificacion('Ingrese la contraseña del usuario', 'warning')
          inputEls.current['contrasena'].focus()
          return
        }

        if (showSuccess === 'red') {
          msgNotificacion('La contraseña no cumple con los requisitos de validación.', 'warning')
          return
        }
      }

      // Si es agregando.
      if (!isEdit) {
        SeguridadService.agregarUsuario(data)
          .then((response) => {

            if (!response) {
              msgNotificacion('Error de conexión con la API, consulte al administrador del sitio.', 'error')
              return
            }

            if (response.Codigo === 1) {
              msgNotificacion(response.Mensaje, 'success')
              limpiar()
              setNoChanges(false)
              setOpenModal(false)
            } else {
              msgNotificacion(response.Mensaje, 'warning')
              setNoChanges(true)
            }
          })
          .catch((error) => {
            console.log('Error:', error.message)
          })
      } else {
        SeguridadService.editarUsuario(data)
          .then((response) => {

            if (!response) {
              msgNotificacion('Error de conexión con la API, consulte al administrador del sitio.', 'error')
              return
            }

            if (response.Codigo === 1) {
              setNoChanges(false)
              setOpenModal(false)
              msgNotificacion(response.Mensaje, 'success')
            } else {
              setNoChanges(true)
              msgNotificacion(response.Mensaje, 'warning')
            }
          })
          .catch((error) => {
            console.log('Error:', error.message)
          })
      }
    } catch (error) {
      console.error(error)
    }
  }

  const renderizarUsuario = () => {
    setValues({
      ...values,
      nombre: dataUsuario?.Nombre,
      isBloqueado: dataUsuario?.IsBloqueado
    })

    setRolSelected(dataUsuario?.IdRol)
    setEmpleadoSelected({ ...empleadoSelected, id: dataUsuario?.IdEmpleado, label: dataUsuario?.NombreCompleto })
  }

  useEffect(() => {
    try {
      if (openModal) {
        getEmpleados()

        if (isEdit) {
          renderizarUsuario()
          setHIddenContrasena(true)
        } else {
          limpiar()
          setHIddenContrasena(false)
        }
      }
    } catch (error) {
      console.error(error)
    }
  }, [openModal])

  return (
    <div>
      <Modal
        open={openModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        closeAfterTransition
        slotProps={{
          backdrop: {
            timeout: 1000
          }
        }}
      >
        <Box sx={CustomStyles}>
          <Typography id="modal-modal-title" className='mb-4' textAlign={'center'} variant="h4" component="h2">
            {!isEdit ? 'Crear nuevo usuario' : `Editando usuario ${dataUsuario?.Nombre}`}
            <PersonIcon style={{ fontSize: '1.1em', marginLeft: '10px' }} />
          </Typography>

          <Grid container spacing={1}>
            <Grid item xs={12} md={6} className='mt-2'>
              <TextField
                id='txtNombre'
                name='nombre'
                variant='outlined'
                label='Nombre de usuario'
                placeholder='Nombre de suario'
                size='small'
                autoFocus
                required
                value={values.nombre}
                inputRef={(el) => (inputEls.current['nombre'] = el)}
                fullWidth
                onChange={handleChange}
                InputLabelProps={{
                  className: 'LabelMui'
                }}
              />
            </Grid>

            <Grid item xs={12} md={6} className='mt-2'>
              <Box sx={{ minWidth: 200 }}>
                <FormControl fullWidth size='small'>
                  <InputLabel id='RolesLabel' className='text-transform-none'>
                    Roles
                  </InputLabel>
                  <Select
                    id='cboRoles'
                    name='rolSelected'
                    label='Roles'
                    value={rolSelected}
                    onChange={handleSelectChange}
                    fullWidth
                    size='small'
                    className='text-start'
                    displayEmpty
                    inputRef={(el) => (inputEls.current['rolSelected'] = el)}
                  >
                    {
                      dataRoles?.map((item) => {
                        return (
                          <MenuItem key={item.Id} value={item.Id}>{item.Nombre}</MenuItem>
                        )
                      })
                    }
                  </Select>
                </FormControl>
              </Box>
            </Grid>

            <Grid item xs={12} md={12} className='mt-2'>
              <Autocomplete
                id="cboEmpleados"
                disableClearable
                getOptionLabel={option => (option.id + ' - ' + option.label)}
                isOptionEqualToValue={(option, value) => option.value === value.value}
                options={dataEmpleados}
                fullWidth
                value={empleadoSelected || null}
                onChange={handleChangeEmpleado}
                renderInput={(params) => <TextField {...params} label="Selecciona el empleado" />}
              />
            </Grid>

            <Grid item xs={12} md={12} className='mt-2' hidden={hiddenContrasena}>
              <FormControl sx={{ width: '100%' }} variant="outlined">
                <InputLabel
                  htmlFor="outlined-adornment-password"
                >
                  Contraseña
                </InputLabel>
                <OutlinedInput
                  id="outlined-adornment-password"
                  type={showPassword ? 'text' : 'password'}
                  className='h-input'
                  placeholder='Digita la contraseña'
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                  startAdornment={
                    <InputAdornment position="start">
                      <LockIcon color='info' />
                    </InputAdornment>
                  }
                  label="Password"
                  onChange={(e) => validate(e.target.value)}
                  inputRef={(el) => (inputEls.current['contrasena'] = el)}
                />
                {
                  errorMessage === ''
                    ?
                    null
                    :
                    <span style={{ fontWeight: 'bold', color: showSuccess }}>{errorMessage}</span>
                }
              </FormControl>
            </Grid>

            <Grid item xs={12} md={12} className='mt-1 text-center' hidden={!isEdit ? true : false}>
              <FormControl>
                <FormLabel id="demo-row-radio-buttons-group-label">¿Está bloqueado?</FormLabel>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  value={values.isBloqueado}
                  name="isBloqueado"
                  onChange={handleChange}
                  defaultValue={false}
                  row
                >
                  <FormControlLabel value={true} control={<Radio />} label="Si" />
                  <FormControlLabel value={false} control={<Radio />} label="No" />
                </RadioGroup>
              </FormControl>
            </Grid>
          </Grid>

          <Stack spacing={2} direction="row-reverse" marginTop={2}>
            <Button variant="contained" className='text-transform-none' onClick={guardarCambios}>
              Guardar cambios
            </Button>
            <Button variant="outlined" className='text-transform-none' onClick={handleClose}>
              Cancelar
            </Button>
          </Stack>
        </Box>
      </Modal>
    </div>
  )
}

export default ModalUsuarios;